"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "VIGAS H ALA ANCHA",
  link: "/ProductsPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_h_ala_ancha.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_h_ala_ancha.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_h_ala_ancha.png-wvc-sizes",
    alt: "Vigas H de ala ancha para construcción estructural"
  }
}, {
  title: "VIGAS IPE",
  link: "/ProductsPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_ipe_acero.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_ipe_acero.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_ipe_acero.png-wvc-sizes",
    alt: "Vigas IPE de acero estructural de alta resistencia"
  }
}, {
  title: "VIGAS UPN",
  link: "/ProductsPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_upn_perfil.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_upn_perfil.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/vigas_upn_perfil.png-wvc-sizes",
    alt: "Vigas UPN perfiles de acero para proyectos industriales"
  }
}];
export default function SubProductos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262397" id="sub-productos" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <h2 className="text-center text-xl md:text-2xl text-foreground font-default mb-10 md:mb-16 uppercase tracking-wider">
          Soluciones en Acero Estructural
        </h2>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => <Link key={i} to={service.link} data-index={i} className="relative group overflow-hidden rounded-md aspect-[3/4] block shadow-md">
              <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-primary/40 transition-colors duration-500 group-hover:bg-primary/60" />
              <div className="absolute inset-0 flex items-center justify-center p-6">
                <span className="text-white text-lg md:text-xl tracking-widest uppercase font-default border-b-2 border-accent pb-1 transition-all duration-300 group-hover:border-white group-hover:text-white text-center">
                  {service.title}
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}